import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
  TablePagination,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';

function WheelRepairHistory({ wheelTransection }) {
  console.log('wheelTransectionRepair', wheelTransection);
  return (
    <div className="py-2">
      <Card>
        <CardContent>
          <div className="py-1 font-bold  ">ประวัติการซ่อมยาง</div>
          <Table>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <h1 className="font-bold">ลำดับ </h1>
                    </TableCell>
                    <TableCell align="center">
                      <h1 className="font-bold">วันที่</h1>
                    </TableCell>
                    <TableCell align="center">
                      <h1 className="font-bold">ป้ายทะเบียน</h1>
                    </TableCell>
                    <TableCell align="center">
                      <h1 className="font-bold">หัวข้อการซ่อม</h1>
                    </TableCell>
                    <TableCell align="center">
                      <h1 className="font-bold">ราคา</h1>
                    </TableCell>
                    <TableCell align="center">
                      <h1 className="font-bold">หมายเหตุ</h1>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.isEmpty(
                    _.filter(wheelTransection?.rows, { repairStatus: true }),
                  ) ? (
                    <TableRow>
                      <TableCell align="center" colSpan={6}>
                        ไม่มีข้อมูล
                      </TableCell>{' '}
                    </TableRow>
                  ) : (
                    _.map(
                      _.filter(wheelTransection?.rows, { repairStatus: true }),
                      (each, index) => (
                        <TableRow key={each?._id}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {dayjs(each?.createdAt).format('DD/MM/BB')}
                          </TableCell>
                          <TableCell align="center">
                            {each?.vehicle?.licence_number && (
                              <div>หัวรถ {each?.vehicle?.licence_number}</div>
                            )}
                            {each?.trailertail?.licence_number && (
                              <div>
                                หางรถ {each?.trailertail?.licence_number}
                              </div>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {each?.repairTopic || '-'}
                          </TableCell>
                          <TableCell align="center">
                            {each?.price || '-'}
                          </TableCell>
                          <TableCell align="center">
                            {each?.note || '-'}
                          </TableCell>
                        </TableRow>
                      ),
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}

WheelRepairHistory.propTypes = {
  wheelTransection: PropTypes.object,
};

export default WheelRepairHistory;
